import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

export default function Modal({ title, onClose, size = 'lg', children }) {
  const handleClose = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    onClose && onClose();
  };

  return ReactDOM.createPortal(
    <Fragment>
      <div className="modal-backdrop fade show" onClick={handleClose} />
      <div className="modal fade show" style={{ display: 'block' }}>
        <div className={`modal-dialog modal-${size} modal-dialog-centered`}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="close" onClick={handleClose} aria-label="Sluiten">
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </div>
    </Fragment>,
    document.body
  );
}
